
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { SWRConfig } from 'swr'
import store from 'config/store'
import fetcher from 'helpers/fetcher'
import { injectStore } from 'config/axios'
import ErrorBoundary from 'shared/ErrorBoundary'
import App from './App'
import './main.css'

 injectStore(store)
ReactDOM.render(
   <Provider store={store} >
     <SWRConfig 
      value={{
        fetcher,
        dedupingInterval: 10000,
        onError: (error, key) => {
          if (error.status !== 403 && error.status !== 404) {
            // TODO Implement sentry integration
          }
        },
        onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
          if (error.status === 404) return
          if (retryCount >= 7) return
          setTimeout(() => revalidate({ retryCount }), 5000)
        }
      }}
    >
      <ErrorBoundary>
        <App />
      </ErrorBoundary>,
     </SWRConfig>
    </Provider>,
  
  document.getElementById('root')
)
